import { Box, Button, Drawer } from "@mui/material";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import IconWheel from "./IconWheel";

type MobileNavBarProps = {
    open: boolean,
    handleOpen(b: any): void,
}

const MobileNavBar: React.FC<MobileNavBarProps> = ({ open, handleOpen }) => {
    const { t } = useTranslation();
    const navRoutes = [
        { link: "/", text: t("common.home") },
        { link: "/Wheels", text: t("common.wheels") },
        { link: "/Rollers", text: t("common.rollers") },
        { link: "/Accessories", text: t("common.accessories") }
    ];

    window.onpopstate = () => {

        if (open) {
            handleOpen(false)
        }
    }

    return (
        <>
            <div onClick={() => handleOpen(true)}>
                <IconWheel />
                <Box sx={{ display: { xs: "inline", fontWeight: "bold", fontSize: "16px" } }}>
                    {t("common.appname")}
                </Box>
            </div>
            <Drawer open={open} PaperProps={{ sx: { backgroundColor: "#1976d2", minWidth: "200px", justifySelf: "auto" } }} anchor="left" onClose={() => handleOpen(false)}>
                {navRoutes.map((routes) => {
                    return (<NavLink key={routes.text} to={routes.link} style={{ textDecoration: "none" }} onClick={() => handleOpen(false)} end>
                        {({ isActive }) => (
                            <Button sx={{ my: 2, display: "flex", color: isActive ? "white" : "black" }} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 32 32"><g data-name="92-Arrow Right"><path fill={isActive ? "white" : ""} d="M16 32a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm0-30a14 14 0 1 0 14 14A14 14 0 0 0 16 2z" /><path fill={isActive ? "white" : ""} d="M13.71 24.71 12.3 23.3l7.29-7.3-7.3-7.29L13.7 7.3l8 8a1 1 0 0 1 0 1.41z" /></g></svg>
                                <div style={{ paddingLeft: "10px" }}>
                                    {routes.text}
                                </div>
                            </Button>
                        )}
                    </NavLink>)
                })}
            </Drawer>
        </>
    );
}

export default MobileNavBar;